import React, { useState } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { Info } from "lucide-react";

const InfoDialog = ({ title, description }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Info Icon Button */}
      <button
        onClick={() => setOpen(true)}
        className="ml-2 text-gray-500 hover:text-blue-600"
      >
        <Info className="w-5 h-5" />
      </button>

      {/* Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="bg-white rounded-2xl shadow-lg max-w-[800px] w-full p-6">
            <DialogTitle className="text-lg font-bold mb-3">
              {title}
            </DialogTitle>
            <p className="text-gray-600 mb-4">{description}</p>
            <div className="flex justify-end">
              <button
                onClick={() => setOpen(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Close
              </button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
};

export default InfoDialog;
